import TWalkthroughIvrGuidance from './index.vue';

TWalkthroughIvrGuidance.install = app => {
  app.component(TWalkthroughIvrGuidance.name, TWalkthroughIvrGuidance);
};

export default TWalkthroughIvrGuidance;
